import { render, staticRenderFns } from "./Buro.vue?vue&type=template&id=7727bdc0&scoped=true"
import script from "./Buro.vue?vue&type=script&lang=js"
export * from "./Buro.vue?vue&type=script&lang=js"
import style0 from "./Buro.vue?vue&type=style&index=0&id=7727bdc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7727bdc0",
  null
  
)

export default component.exports